<div fxLayoutAlign="center center" *ngIf="!detectDeviceService.isDesktop() else desktop">
  <div class="game-card">
    <!-- <img (click)="openGameDialog()" src="{{ data.thumbnail.url }}" /> -->
    <a [routerLink]="launchGameUrl" (click)="launchGame($event,gameNameSlug)">
      <div class="thumbnail"  [ngClass]="{ 'bonus_exclude_overlay': isBonusExcludedGame }" 
           [style.background-color]="data.initialLoadColor ? data.initialLoadColor.css : 'rgb(28 146 62 / 59%)'">

        <img width="121px" height="121px" alt="{{data.name}}" data-src="{{ data.thumbnail?.url }}" loading=lazy
             class="swiper-lazy"/>

        <!-- <img *ngIf="data.thumbnailDesktopSquare else oldthumb" loading=lazy alt="{{data.name}}" src="{{ data.thumbnailDesktopSquare?.url }}" /> -->
        <div  [ngSwitch]="badge()">
          <!-- <ng-container *ngSwitchCase="'big_win'">
            <div class="big-win-badge">
              <img class="big-win badge-tag" src="{{licenceService.getKey('badge-bigwin-mobile')}}">
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'hot'">
            <div class="big-win-badge">
              <img class="big-win badge-tag" src="assets/icons/badge-hot-mobile.svg">
            </div>
          </ng-container> -->
          <ng-container *ngSwitchCase="'cash_drops'">
            <div class="badge">
              <img class="cash-drops" src="assets/icons/tag-thumbnail-mobile-kalamba.png">
            </div>
          </ng-container>


          <ng-container *ngSwitchCase="'drops_win'">
            <div class="badge">
              <img src="assets/icons/drops-win-icon.png">
            </div>
          </ng-container>

            <ng-container *ngSwitchCase="'take_prize'">
              <div class="take_prize">
              <img src="assets/icons/take-the-prize-mobile.png">
            </div>
            </ng-container>

            <ng-container *ngSwitchDefault>

            </ng-container>
          </div>
        <!-- <div *ngIf="data.tag?.includes('exclusive')" class="exclusive">
          <img src="assets/icons/tag-lemon-exclusive-mobile.svg">
        </div> -->
        <!-- <div *ngIf="isBonusExcludedGame" class="bonus_exclude">
          <img  src="{{licenceService.getKey('bonus-excluded')}}" alt="bonusExclude"/>
        </div> -->
        <div *ngIf="data.tag?.includes('power_weekends')" class="power-weekends">
          <img src="assets/icons/tag-power-weekends-pragmatic-mobile-2x.png">
        </div>
        <div *ngIf="data?.tag?.includes('holiday_spin_splash')" class="holiday-spin-splash">
          <img src="assets/icons/holiday-spin-splash-mobile-tag-2x.png">
        </div>
        <div *ngIf="data?.tag?.includes('reel_fortune')" class="reel_fortune">
          <img src="assets/icons/ROF-mobile-36x36.png">
        </div>
        <div *ngIf="data?.tag?.includes('spin_gifts')" class="spin_gifts">
          <img src="assets/icons/spin-gifts-mobile-26x40.png">
        </div>
        <!-- <div *ngIf="data.uniquePlayers" fxLayout="row" fxLayoutAlign="center center" class="unique-players">
          <img src="assets/icons/icon-profile-sticky.svg" loading=lazy alt="signup" class="profile-icon"/>
          <span>{{ data.uniquePlayers }}</span>
        </div> -->
        <div class="icon-tags-container">
          <div  *ngIf="isBonusExcludedGame||favouriteGame||isInTopGamesByMaxWin||isInTopGamesByTotalRounds||data.uniquePlayers" 
          [ngClass]="{ 'unique-players-icon-tags': data.uniquePlayers,
          'single_unique-players-icon-tags': !isBonusExcludedGame && !favouriteGame && !isInTopGamesByMaxWin && !isInTopGamesByTotalRounds && data.uniquePlayers}" 
          class="icon-tags">
          <div *ngIf="data.uniquePlayers" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3px" class="unique-players">
            <img src="assets/icons/players-counter-icon.svg" loading=lazy alt="signup" class="profile-icon" />
            <span>{{ data.uniquePlayers }}</span>
          </div>
            <img *ngIf="isBonusExcludedGame" src="{{licenceService.getKey('icon-tag-bonus-excluded')}}" alt="bonusExclude"/>
            <img *ngIf="favouriteGame" src="{{licenceService.getKey('icon-fav')}}" alt="favouriteGame"/>
            <img *ngIf="isInTopGamesByMaxWin" src="{{licenceService.getKey('icon-tag-big-win')}}" alt="bigwin">
            <img *ngIf="isInTopGamesByTotalRounds" src="{{licenceService.getKey('icon-tag-hot')}}" alt="badeHot">
          </div>
          <div *ngIf="data.tag?.includes('exclusive')" class="exclusive">
            <img src="assets/icons/tag-lemon-exclusive-mobile.svg">
          </div>
        </div>
        <ng-template #oldthumb>
          <img width="121px" height="121px" loading=lazy alt="{{data.name}}" src="{{ data.thumbnail?.url }}"/>
        </ng-template>
      </div>
    </a>
    <div class="title" [ngClass]="{ 'bonus_exclude_text': isBonusExcludedGame }">
      {{ data.name }}
    </div>
  </div>
</div>

<ng-template #desktop>
  <div class="desktop">
    <div fxLayoutAlign="start" class="game-card-wrapper">
      <div class="game-card desktop" [ngClass]="'Square'">
        <!-- <img (click)="openGameDialog()" src="{{ data.thumbnail.url }}" /> -->
        <div class="thumbnail"
             [style.background-color]="data.initialLoadColor ? data.initialLoadColor.css : 'rgb(28 146 62 / 59%)'">
          <a [routerLink]="launchGameUrl" [ngClass]="{ 'bonus_exclude_overlay': isBonusExcludedGame }" (click)="launchGame($event,gameNameSlug)">
            <div class="play-effect">
              <img src="assets/desktop/play-button-overlay.svg" alt="play-button-overlay">
            </div>
            <ng-container>
              <img *ngIf="data?.thumbnailDesktopSquare" loading=lazy alt="{{data.name}}"
                   src="{{ data.thumbnailDesktopSquare.url }}"/>
            </ng-container>

            <div  [ngSwitch]="badge()">
              <ng-container *ngSwitchCase="'cash_drops'">
                <div class="badge">
                  <img class="cash-drops" src="assets/icons/tag-thumbnail-mobile-kalamba.png">
                </div>
              </ng-container>
    
              <ng-container *ngSwitchCase="'drops_win'">
                <div class="badge">
                  <img src="assets/icons/drops-win-icon.png">
                </div>
              </ng-container>
    
                <ng-container *ngSwitchCase="'take_prize'">
                  <div class="take_prize">
                  <img src="assets/icons/take-the-prize-mobile.png">
                </div>
                </ng-container>
    
              <ng-container *ngSwitchDefault>
                
              </ng-container>
            </div>

            <div *ngIf="data.tag?.includes('power_weekends')" class="power-weekends">
              <img src="assets/icons/tag-power-weekends-pragmatic-mobile-2x.png">
            </div>
            <div *ngIf="data?.tag?.includes('holiday_spin_splash')" class="holiday-spin-splash">
              <img src="assets/icons/holiday-spin-splash-mobile-tag-2x.png">
            </div>
            <div *ngIf="data?.tag?.includes('reel_fortune')" class="reel_fortune">
              <img src="assets/icons/ROF-mobile-36x36.png">
            </div>
            <div *ngIf="data?.tag?.includes('spin_gifts')" class="spin_gifts">
              <img src="assets/icons/spin-gifts-mobile-26x40.png">
            </div>

            <!-- <div *ngIf="isBonusExcludedGame" class="bonus_exclude">
              <img  src="{{licenceService.getKey('bonus-excluded')}}" alt="bonusExclude"/>
            </div> -->
            <div class="icon-tags-container">
              <div  *ngIf="isBonusExcludedGame||favouriteGame||isInTopGamesByMaxWin||isInTopGamesByTotalRounds||data.uniquePlayers" 
              [ngClass]="{ 'unique-players-icon-tags': data.uniquePlayers,
              'single_unique-players-icon-tags': !isBonusExcludedGame && !favouriteGame && !isInTopGamesByMaxWin && !isInTopGamesByTotalRounds && data.uniquePlayers}" 
              class="icon-tags">
              <div *ngIf="data.uniquePlayers" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3px" class="unique-players">
                <img src="assets/icons/players-counter-icon.svg" loading=lazy alt="signup" class="profile-icon" />
                <span>{{ data.uniquePlayers }}</span>
              </div>
                <img *ngIf="isBonusExcludedGame" src="{{licenceService.getKey('icon-tag-bonus-excluded')}}" alt="bonusExclude"/>
                <img *ngIf="favouriteGame" src="{{licenceService.getKey('icon-fav')}}" alt="favouriteGame"/>
                <img *ngIf="isInTopGamesByMaxWin" src="{{licenceService.getKey('icon-tag-big-win')}}" alt="bigwin">
                <img *ngIf="isInTopGamesByTotalRounds" src="{{licenceService.getKey('icon-tag-hot')}}" alt="badeHot">
              </div>
              <div *ngIf="data.tag?.includes('exclusive')" class="exclusive">
                <img src="assets/icons/tag-lemon-exclusive-mobile.svg">
              </div>
            </div>
          </a>
        </div>
        <div class="title" [ngClass]="{ 'bonus_exclude_text': isBonusExcludedGame }">
          {{ data.name }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
